import localeResources, { type SupportedLocale } from '../locales/index'
import { NAMESPACES } from './namespaces'

export { NAMESPACES }
export type { TranslationNamespace } from './namespaces'
export type { SupportedLocale }

export const SUPPORTED_LOCALES = Object.freeze(Object.keys(localeResources)) as readonly SupportedLocale[]

export const DEFAULT_LOCALE: SupportedLocale = 'en'

export function normalizeLocale(tag: string | undefined | null): SupportedLocale {
  if (!tag || typeof tag !== 'string') {
    return DEFAULT_LOCALE
  }

  const primary = tag.trim().toLowerCase().split('-')[0]
  if ((SUPPORTED_LOCALES as readonly string[]).includes(primary)) {
    return primary as SupportedLocale
  }

  return DEFAULT_LOCALE
}

/** i18next `resources` object for init(). */
export function buildI18nResources(): Record<string, Record<string, object>> {
  return localeResources
}
